import { unstable_getScrollbarSize as getScrollbarSize } from '@material-ui/utils';
export default getScrollbarSize;